module.exports = __webpack_public_path__ + "static/media/feather-alt.d14fd4f0.svg";